import React from 'react'
import styled from 'styled-components'
import Container from '../system/container/container'
import breakpoints from '../../styles/breakpoints'
import { fonts, colors } from '../../styles/theme'
import Filters from './filters'

const StyledFilterHero = styled.div`
  background-size: cover;
  background-position: center 75%;
  background-color: ${colors.primary900};
  background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.54), rgba(0, 0, 0, 0.54)),
    url('/images/hero-bg.jpg');
  color: ${props => props.theme.colors.typography.light.text};
  height: 200px;

  @media (min-width: ${breakpoints.md}) {
    height: 400px;
  }
`

const HeroContainer = styled(Container)`
  display: grid;
  align-content: center;
  grid-auto-rows: minmax(min-content, max-content);
  grid-row-gap: ${props => props.theme.spacing.base500};
  height: 100%;
`

const H1 = styled.h1`
  font-family: ${fonts.raleway};
  font-weight: lighter;

  @media (max-width: ${breakpoints.md}) {
    b {
      display: block;
    }
  }

  @media (min-width: ${breakpoints.md}) {
    margin-top: 0;
  }
`

const DesktopFilters = styled(Filters)`
  display: none;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: ${props => props.theme.spacing.base400};

  @media (min-width: ${breakpoints.lg}) {
    display: grid;
  }
`

const EventsHero = () => {
  return (
    <StyledFilterHero>
      <HeroContainer>
        <H1>
          <b>Upcoming</b> Events
        </H1>

        <DesktopFilters variant="solid" isMobile={false} />
      </HeroContainer>
    </StyledFilterHero>
  )
}

export default EventsHero
